import React from "react";
import TerminalActionButton from "../../UI/TerminalActionButton/TerminalActionButton";
import CssClasses from "./TerminalActions.css";
import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";

import beepHigh from "../../../assets/sounds/beep_high.mp3";

let _props = null;

const TerminalActions = props => {
  _props = props;

  const buttonTypes = [
    {
      id: 1,
      icon: "add_money",
      title: "Uplati novac"
    },
    {
      id: 2,
      icon: "wallet",
      title: "Ispiši potvrdu za saldo"
    },
    {
      id: 3,
      icon: "ticket",
      title: "Provjera listića",
      color: "yellow"
    },
    {
      id: 6,
      icon: "admin_invoice",
      title: "Provjera potvrde za isplatu",
      color: "yellow"
    },
    {
      id: 4,
      icon: "location",
      title: "Lokator kladomata"
    },
    {
      id: 5,
      icon: "aircash",
      title: "AirCash - Uplata karticom"
    },
    {
      id: 100,
      icon: "swap",
      title: "Zamijeni ekrane"
    },
    // {
    //   id: 1001,
    //   icon: "admin_settings",
    //   title: "***** REFRESH *****"
    // },
    {
      id: 1002,
      icon: "admin_settings",
      title: "***** ZATVORI *****"
    }
  ];

  return (
    <div className={CssClasses.container}>
      <audio
        ref={sound => {
          this.beepHigh = sound;
        }}
      >
        <source src={beepHigh} type="audio/mpeg" />
      </audio>
      {buttonTypes.map(btn => {
        return (
          <TerminalActionButton
            icon={btn.icon}
            color={btn.color}
            onButtonClicked={specialOptionButtonClick}
            title={btn.title}
            key={btn.id}
            id={btn.id}
            isActive={btn.id === props.currentActionButton}
          />
        );
      })}
    </div>
  );
};

const specialOptionButtonClick = id => {
  console.log("Button click.." + id);

  if (this.beepHigh) {
    this.beepHigh.play();
  }

  if (id === 100) {
    //okini swap
    console.log("CEF IS: ", window.cefCustomObject);

    window.cefCustomObject.swapForms();
    return;
  }

  if (id === 1001) {
    //okini swap
    console.log("CEF IS: ", window.cefCustomObject);

    window.cefCustomObject.refreshTheApp();
    return;
  }

  if (id === 1002) {
    //okini zatvori
    console.log("CEF IS: ", window.cefCustomObject);

    window.cefCustomObject.closeTheApp();
    return;
  }

  if (id === _props.currentActionButton) {
    //gasi
    _props.setTerminalActionsActiveButton(0);
    //nakon timeouta upali
    setTimeout(() => {
      _props.setCanShowExtraPrematchBets(true);
      console.log("PALIM...");
    }, 1000);
  } else {
    //prebaci
    _props.setTerminalActionsActiveButton(id);
    //gasi extras
    _props.setCanShowExtraPrematchBets(false);
  }

  //svakako gasi prematch extra bets
  _props.onSetPrematchExtraBetsID(-1);

  //_props.onChangeServerStatus(id);
  // if (id === 4) {
  //   _props.onChangeServerStatus(200);
  // } else {
  //   _props.onChangeServerStatus(id);
  // }
};

const mapStateToProps = state => {
  return {
    currentActionButton: state.rrNavigation.currentActionButton
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setTerminalActionsActiveButton: buttonID =>
      dispatch(StoreActions.SetTerminalActionsActiveButton(buttonID)),
    onChangeServerStatus: code =>
      dispatch(StoreActions.ChangeServerStatus(code)),
    setCanShowExtraPrematchBets: canShow =>
      dispatch(StoreActions.SetCanShowExtraPrematchBets(canShow)),
    onSetPrematchExtraBetsID: betsID =>
      dispatch(StoreActions.ChangeCurrentPrematchExtraBetsID(betsID))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TerminalActions);



// WEBPACK FOOTER //
// ./src/Components/Navigation/TerminalActions/TerminalActions.js